import type { CSSObject } from '@emotion/react'
import { isNumber } from 'lodash'
import { Label } from '../../Label/Label'
import { InProgressEventWave } from './InProgressEventWave'

export const BadgeContent = ({
  showLabel,
  progressText,
  progressPercent,
  children,
  height,
  containerCSS,
  isSelected,
  irrigationZoneName,
}: {
  showLabel: boolean
  progressText?: string
  progressPercent?: number
  children: React.ReactNode
  height: number
  containerCSS?: CSSObject
  isSelected?: boolean
  irrigationZoneName: string
}) => {
  return (
    <>
      {showLabel && <Label bottom={height + 18}>{irrigationZoneName}</Label>}
      <div
        /* Pill Wrapper */
        css={{
          width: '100px',
          height: '60px',
          overflow: 'hidden',
          padding: '14px',
          display: 'flex',
          alignContent: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          position: 'relative',
          cursor: 'pointer',
          zIndex: 2,
        }}
      >
        <div
          /* Pill Inner Text */
          css={{
            width: '100%',
            zIndex: 1,
            color: '#fff',
            display: 'flex',
            borderRadius: '6px',
            alignContent: 'center',
            justifyContent: 'center',
            fontSize: 14,
            fontWeight: 'bold',
            ...containerCSS,
          }}
        >
          {children}
        </div>
        <div
          /* Pill Shape */
          css={{
            border: `2px solid ${(isSelected && 'yellow') || 'white'}`,
            width: 'calc(100% - 24px)',
            height: 'calc(100% - 24px)',
            backgroundColor: 'transparent',
            borderRadius: '95.2px',
            overflow: 'hidden',
            position: 'absolute',
            ...containerCSS,
          }}
        >
          {/* If there is progress, then there is an ongoing current event  */}
          {isNumber(progressPercent) && <InProgressEventWave progressPercent={progressPercent} />}
        </div>
      </div>
      {progressText && (
        <div
          css={{
            position: 'absolute',
            left: '80px',
            top: '18px',
            backgroundColor: '#000',
            color: '#fff',
            fontSize: '12px',
            zIndex: 1,
            borderRadius: '15%',
            padding: '5px 15px 5px 15px',
            width: '120px',
          }}
        >
          {progressText}
        </div>
      )}
    </>
  )
}
